import useApiController from "@hooks/useApiController";

export default function useSalonTrackingController(salonId: string | number): Admin.Controllers.SalonTracking {
    const { index, store, show, update, destroy } = useApiController(`/api/admin/salons/${salonId}/trackings`)

    return { index, store, show, update, destroy }
}